import { Component, Input } from '@angular/core';
import { Product, ProductAttribute } from '../../../../graphql/generated/generated-types';


@Component({
  selector: 'app-product-details-params',
  standalone: true,
  imports: [],
  templateUrl: './product-details-params.component.html',
  styleUrl: './product-details-params.component.scss'
})
export class ProductDetailsParamsComponent {
  @Input() attributes: ProductAttribute[] = [];
  public showAllAttributes: boolean = false;

  toggleShowMore() {
    this.showAllAttributes = !this.showAllAttributes;
  }
  toggleShowLess() {
    this.showAllAttributes = !this.showAllAttributes;
  }
}
